import { MerchantAccountLinkOutput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { driverApi } from '../services/network/Api';

const fetchOnboardingLink = () =>
  driverApi.get<void, MerchantAccountLinkOutput>('/v1/merchant/account/link/onboarding');

export const useFetchOnboardingLink = () => useMutation({ mutationFn: fetchOnboardingLink });
